import { format } from 'date-fns';
import checkAccess from '../../../utils/roles/checkAccess';
import getFranchiseRegion from '../../../utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/reports-influencers',
};

export const getColumns = () => [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    nameForSort: 'influencer_promotion_name',
  },
  {
    id: 'startDate',
    label: 'Start Date',
    align: 'center',
    nameForSort: 'start_date',
    customValue: (item) => format(new Date(item.startDate), 'dd/MM/yyyy'),
  },
  {
    id: 'endDate',
    label: 'End Date',
    align: 'center',
    nameForSort: 'end_date',
    customValue: (item) => format(new Date(item.endDate), 'dd/MM/yyyy'),
  },
  {
    id: 'voucherValue',
    label: 'Promo Code',
    align: 'center',
    nameForSort: 'voucher_value',
  },
  {
    id: 'codesUsed',
    label: 'Codes Used',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'influencerReward',
    label: 'Influencer Reward',
    align: 'center',
    disableSort: true,
  },
];

export const getFilters = ({ region, influencerName, dateRange, options }) => [
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'influencerName',
    type: 'select',
    label: 'Influencer',
    value: influencerName.value,
    action: influencerName.change,
    items: options?.influencers?.length ? ['all', ...options.influencers] : ['all'],
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
];
